import WorkflowTab from "./WorkflowTab";

export default function RPAEditor({
  workflowId,
  actionId,
}: { workflowId: string; actionId: string }) {
  return (
    <div className="w-full h-[80vh] flex flex-col overflow-hidden">
      <div className="flex-1 flex flex-col overflow-hidden">
        <WorkflowTab workflowId={workflowId} actionId={actionId} />
      </div>
    </div>
  );
}
